<template>
  <div>
    <div class="stages__filters">
      <CustomSelect
        :options="floors"
        label="Этаж"
        style="width: 100px;"
        optionValueKey="floor"
        optionLabelKey="floor_name"
        :value="filters.floor"
        @change="value => onChange('floor', value)"
      />
      <CustomSelect
        :options="placementTypes"
        label="Тип"
        style="width: 200px;"
        optionValueKey="placement_type_id"
        optionLabelKey="placement_type_name"
        :value="filters.placement_type_id"
        @change="value => onChange('placement_type_id', value)"
      />
    </div>

    <CustomTable
      title="Этапы"
      :rowsData="data"
      :columns="columns"
      :stickyHeader="false"
      :loading="isFetching"
      :custom-body="true"
      :small="true"
    >
      <template #top-right>
        <slot name="top-right">
          <q-btn
            :loading="isFetching"
            @click="refetch"
            color="primary"
            size="sm"
          >
            <q-icon name="replay" />
          </q-btn>
        </slot>
      </template>

      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            <q-btn
              v-if="props.row.floor_map_id"
              size="sm"
              color="secondary"
              padding="xs"
              @click="() => goToSchema(props.row)"
            >
              <q-icon name="far fa-map" />
              <q-tooltip>Открыть схему этажа</q-tooltip>
            </q-btn>
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            Блок {{ props.row.block_name }}
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.floor }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.placement_type_name }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.work_set_check_group_name }}
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <q-btn
              @click="() => props.row.check_status_code === 'DEFECT' && handleCheckInfoClick(props.row)"
              outline
              no-caps
              class="status-badge"
              :style="`cursor: ${props.row.check_status_code === 'DEFECT' ? 'pointer' : 'default'}`"
              :color="getStagesBadgeColor(props.row.check_status_code)"
              :label="props.row.check_status"
            />
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.call_employee_fio }}
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.call_date }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.check_employee_fio }}
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.check_date }}
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>

  <q-drawer
    v-model="floorDetailMode"
    :width="windowWidth < drawerWidth ? windowWidth : drawerWidth"
    :overlay="true"
    side="right"
    bordered
  >
    <ResidentialFloorDetail
      v-if="selectedData.floor_map_id"
      :goBack="onBack"
      :activeData="selectedData"
      :params="params"
    />
  </q-drawer>
</template>

<script setup>
import { ref } from 'vue'
import CustomTable from '@/components/common/CustomTable'
import CustomTableCell from '@/components/common/CustomTable/custom-table-cell'
import CustomSelect from '@/components/form/CustomSelect'
import ResidentialFloorDetail from './ResidentialFloorDetail.vue'

import {
  entranceStagesColumns,
  getEntranceDocumentFloors,
  getEntranceStages,
  getPlacementTypes,
  getStagesBadgeColor,
} from './services'

import { MODAL_NAMES } from '@/constants'
import { useQuery } from '@tanstack/vue-query'
import { useAppStore } from '@/services/store/app'

const {activeData, params, projectId} = defineProps({
  activeData: Object,
  params: Object,
  projectId: Number,
})

const {showModal} = useAppStore()

const columns = entranceStagesColumns
const drawerWidth = 1250
const floorDetailMode = ref(false)
const selectedData = ref({})
const filters = ref({
  floor: '',
  placement_type_id: ''
})

const windowWidth = ref(window.innerWidth)

const {data, isFetching, refetch} = useQuery({
    queryKey: ['stages'],
    queryFn: () => getEntranceStages({...filters.value, ...params, project_id: projectId })
  })
const {data: floors} = useQuery({
    queryKey: ['floors'],
    queryFn: () => getEntranceDocumentFloors(params)
  })
const {data: placementTypes} = useQuery({
    queryKey: ['placementTypes'],
    queryFn: () => getPlacementTypes()
  })

const goToSchema = (row) => {
  floorDetailMode.value = true
  selectedData.value = { ...activeData, ...row }
}

const onBack = () => {
  floorDetailMode.value = false
  selectedData.value = {}
}

const handleCheckInfoClick = (row) => {
  showModal(MODAL_NAMES.checkGroupHistory, {
    title: row.work_set_check_group_name || '',
    data: {
      ...row,
      params: {
        placement_type_id: row.placement_type_id,
        work_set_check_group_id: row.work_set_check_group_id,
        project_id: projectId,
        project_type_id: params.project_type_id,
      }
    }
  })
}

const onChange = (key, value) => {
  filters.value[key] = value
  refetch()
}
</script>

<style scoped lang="scss">
.stages__filters {
  margin-bottom: 25px;
  display: flex;
  gap: 20px;
  align-items: flex-end;
  flex-wrap: wrap;
}
.status-badge {
  font-size: 12px;
  line-height: 15px;
  min-height: 25px;
  font-weight: 500;
  padding: 2px 10px;
  border-radius: 4px;
}
</style>
